import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { AlertTriangle, CheckCircle, XCircle, ChevronDown, ChevronUp } from 'lucide-react';

const UploadValidation = ({ errors = [], warnings = [], canContinue = true }) => {
  const [expanded, setExpanded] = useState(true);

  if (!errors.length && !warnings.length) return null;

  return (
    <Card className={`shadow-md ${errors.length ? 'border-red-300 bg-red-50' : 'border-amber-300 bg-amber-50'}`} data-testid="upload-validation">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base flex items-center gap-2">
            {errors.length ? <XCircle className="h-5 w-5 text-red-600" /> : <AlertTriangle className="h-5 w-5 text-amber-600" />}
            Upload Validation: {errors.length ? `${errors.length} Error(s)` : ''} {warnings.length ? `${warnings.length} Warning(s)` : ''}
          </CardTitle>
          <div className="flex items-center gap-2">
            {canContinue && warnings.length > 0 && !errors.length && (
              <Badge className="bg-green-100 text-green-800">Can proceed with warnings</Badge>
            )}
            {errors.length > 0 && (
              <Badge className="bg-red-100 text-red-800">Fix errors to continue</Badge>
            )}
            <Button variant="ghost" size="sm" onClick={() => setExpanded(!expanded)}>
              {expanded ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
            </Button>
          </div>
        </div>
      </CardHeader>
      {expanded && (
        <CardContent>
          <div className="space-y-2">
            {errors.map((err, i) => (
              <div key={`e-${i}`} className="flex items-start gap-2 text-sm">
                <XCircle className="h-4 w-4 text-red-600 mt-0.5 flex-shrink-0" />
                <span className="text-red-800">{err}</span>
              </div>
            ))}
            {warnings.map((warn, i) => (
              <div key={`w-${i}`} className="flex items-start gap-2 text-sm">
                <AlertTriangle className="h-4 w-4 text-amber-600 mt-0.5 flex-shrink-0" />
                <span className="text-amber-800">{warn}</span>
              </div>
            ))}
          </div>
          {canContinue && !errors.length && (
            <p className="text-xs text-amber-700 mt-3 pt-3 border-t border-amber-200">
              Analysis can continue by ignoring these warnings. Components with missing data will be excluded from affected calculations.
            </p>
          )}
        </CardContent>
      )}
    </Card>
  );
};

export default UploadValidation;
